import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export default function VerifyEmailPage() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Check your inbox</CardTitle>
        <CardDescription>We sent you a verification link.</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          Click the link in the email we just sent. Once verified, come back and{" "}
          <Link to="/sign-in" className="text-foreground underline-offset-4 hover:underline">
            sign in
          </Link>
          .
        </p>
      </CardContent>
    </Card>
  );
}
